import { render, staticRenderFns } from "./NomineeDetails.vue?vue&type=template&id=594f39c4"
import script from "./NomineeDetails.vue?vue&type=script&lang=js"
export * from "./NomineeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports